import axios from 'axios';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

export const getApiLog = async (filter: any) => { 
  const BearerToken = Cookies.get(constant.Cookie_Name);
  let params = '?per_page=5000';
  let restype = 'json';

  if (filter.from) {
    params += '&from_date=' + filter.from;
  }
  if (filter.to) {
    params += '&to_date=' + filter.to;
  }
  if (filter.portal_id) {
    params += '&portal_id=' + filter.portal_id;
  }
  if (filter.type) {
    params += '&type=' + filter.type;
  }
  try {
    const response = await axios.get(constant.API_BASEPATH + '/api-log' + params, { headers: { "Authorization": `Bearer ${BearerToken}` }, responseType: restype });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const getApiLogById = async (id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.get(constant.API_BASEPATH + '/api-log/' + id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
}; 